var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentHumm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "07414jlz2a",
    d: "M0.087 0.094L4.774 0.094 4.774 4.91 0.087 4.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t2xcjt4y7c",
    d: "M0.064 0.069L0.637 0.069 0.637 0.25 0.064 0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "93wr142gbe",
    d: "M0.044 0.056L13.371 0.056 13.371 4.905 0.044 4.905z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 -58) translate(108 58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5,
    height: 21.5,
    x: 0.25,
    y: 0.25,
    fill: "#FFF",
    stroke: "#C7C7C7",
    strokeWidth: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 7) translate(13.896 1.941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x4ujibne2b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#07414jlz2a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F26B22",
    d: "M1.164 4.91c-.028-.075-.103-.06-.159-.08-.499-.167-.788-.51-.88-1.024-.042-.24-.033-.48-.033-.72 0-.936.002-1.873-.005-2.81 0-.14.035-.185.18-.181.387.01.776.008 1.164 0 .13-.003.171.029.17.166-.007.798-.003 1.596-.003 2.394v.076c0 .484.129.717.446.811.423.127.968-.045 1.186-.37.044-.065.032-.133.032-.2.001-.894.005-1.787-.003-2.68-.002-.163.049-.202.204-.198.382.011.765.01 1.146 0 .139-.003.165.043.165.172-.005 1.457-.005 2.914 0 4.37 0 .125-.028.166-.157.163-.394-.007-.79-.007-1.184 0-.133.003-.185-.037-.172-.172.01-.104.002-.21.002-.366-.225.212-.436.356-.67.468-.165.079-.355.082-.511.181H1.89c-.191-.032-.383-.032-.574 0h-.153z",
    mask: "url(#x4ujibne2b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 7) translate(15.15 6.747)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3pqm51cuod",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t2xcjt4y7c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F3772F",
    d: "M.064.25c.19-.153.382-.145.573 0H.064z",
    mask: "url(#3pqm51cuod)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 7) translate(19.015 1.837)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nbtgsao6kf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#93wr142gbe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F26B22",
    d: "M1.554.74c.335-.312.684-.508 1.09-.6.302-.07.605-.074.907 0 .412.1.703.342.876.76.225-.269.47-.483.775-.616.479-.209.973-.292 1.49-.174.297.068.544.221.704.482.073.117.11.105.206.024C8.154.16 8.781-.023 9.49.15c.351.086.623.288.776.62.063.138.093.096.17.012.523-.564 1.168-.795 1.93-.653.602.113.975.543.99 1.18.022.854.011 1.71.013 2.565.001.298-.003.596.003.894.002.096-.022.136-.126.135-.413-.005-.828-.007-1.242 0-.141.003-.13-.077-.13-.17.002-.754.001-1.508.001-2.262v-.305c-.002-.258-.01-.525-.275-.664-.29-.153-.581-.097-.852.067-.228.138-.358.31-.348.614.026.841.006 1.685.012 2.527.001.147-.034.2-.19.195-.382-.012-.765-.01-1.147 0-.142.003-.182-.035-.18-.18.006-.874.003-1.748.003-2.623 0-.543-.293-.776-.824-.654-.233.053-.409.197-.567.368-.06.065-.04.143-.04.217-.001.893-.004 1.787.003 2.68 0 .148-.037.196-.19.192-.389-.011-.778-.01-1.166-.001-.133.003-.172-.034-.17-.169.005-.912-.007-1.825.007-2.737.006-.352-.231-.606-.657-.576-.251.017-.462.127-.645.298-.1.092-.146.191-.145.332.006.893 0 1.786.007 2.68 0 .13-.026.175-.165.172-.388-.009-.777-.01-1.165 0-.145.004-.182-.04-.18-.182.006-.868-.013-1.736.007-2.604.016-.69-.533-.798-.967-.628-.138.054-.252.145-.361.244-.09.082-.129.173-.128.3.006.893 0 1.786.007 2.68 0 .152-.043.194-.193.19-.389-.01-.778-.007-1.166 0-.114 0-.155-.032-.155-.15.004-1.47.003-2.94 0-4.41C.045.238.074.199.185.2c.414.006.828.005 1.242.001.098 0 .136.032.13.132-.008.12-.002.24-.002.407",
    mask: "url(#nbtgsao6kf)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F26B22",
    d: "M0 1.19c.403.032.764.032 1.12-.06.132-.035.245-.098.344-.193C2.73-.27 4.704-.315 6.02.827c.125.108.135.17.009.293-.7.683-1.389 1.378-2.082 2.069-.065.065-.143.134-.063.225.091.103.171.021.24-.047C5.145 2.349 6.168 1.333 7.185.311c.102-.104.148-.11.24.01.94 1.232.88 2.898-.157 4.033-.072.078-.095.154-.095.254.003.653-.002 1.306.004 1.958.001.128-.028.175-.168.175-1.114-.006-2.23.005-3.344-.005-1.6-.015-3.06-1.36-3.217-2.941-.04-.408-.03-.809.066-1.208.067-.284-.043-.536-.152-.786-.09-.208-.221-.394-.362-.61M10.473 2.585c.296-.28.599-.466.952-.567.426-.122.854-.133 1.28-.013.547.153.9.589.934 1.188.025.436.012.874.013 1.31.001.685-.003 1.369.003 2.053.002.136-.025.19-.176.185-.388-.01-.777-.009-1.165 0-.136.003-.171-.039-.17-.17.005-.805 0-1.61.003-2.414 0-.324.003-.662-.35-.817-.375-.166-.744-.1-1.08.136-.172.12-.256.263-.251.49.016.862.002 1.724.01 2.585.002.154-.043.194-.192.19-.382-.01-.765-.007-1.146-.001-.124.002-.181-.021-.181-.164.004-2.052.004-4.105 0-6.157 0-.122.032-.165.16-.162.402.008.803.008 1.204 0 .135-.004.154.05.154.165-.005.646-.002 1.292-.002 1.938v.225z",
    transform: "translate(2 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFBF9",
    d: "M1.945 1.636c.216.096.356.077.435-.05.08-.13.04-.26-.122-.406.151-.083.33-.049.467.088.144.146.176.36.081.543-.091.176-.306.28-.497.244-.203-.04-.338-.188-.364-.419",
    transform: "translate(2 7)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHumm);
export default __webpack_public_path__ + "static/media/payment-humm.de18063c385d3c2424d1df9d37467399.svg";
export { ForwardRef as ReactComponent };